/* MOTUS: filmy w sekcjach modelu (snippets/motus-sekcja-modelu.liquid, .motus-sm__wideo), 27.09.
   W HTML film ma preload="none" i plakat, bez autoplay i bez kontrolek (od 28.09, ramka odtwarzacza na telefonie):
   dopóki film nie jest blisko ekranu, nic się nie pobiera. Ten skrypt włącza film (bez dźwięku, w pętli), gdy jest najwyżej
   200 px od ekranu (IntersectionObserver), i zatrzymuje go, gdy się oddali. Bez autostartu przy prefers-reduced-motion: reduce
   i w trybie oszczędzania danych (widać plakat = pierwsza klatka).
   Pauza klienta (28.09, WCAG 2.2.2): dotknięcie / klik filmu (ramka .motus-sm__wideo-ekran) albo przycisk
   .motus-sm__wideo-pauza (widoczny przy fokusie z klawiatury) przełącza film. Bez nakładki, tylko zmiana stanu.
   Pauza klienta zostaje zapamiętana (przewijanie jej nie znosi), start klienta działa też przy ograniczonym ruchu
   i oszczędzaniu danych (od tej chwili ten film gra przy ekranie jak pozostałe). Napis przycisku mówi, co zrobi naciśnięcie.
   Pauza, której nie zrobił ani skrypt, ani klient (np. iOS przy przełączeniu aplikacji), nie blokuje filmu: rusza po powrocie
   na kartę albo przy następnym zbliżeniu. Tylko film z atrybutem controls (gdyby wrócił) traktuje taką pauzę jak pauzę klienta.
   Snippet dołącza plik przy każdym filmie, więc skrypt działa raz na stronę. Bez zewnętrznych bibliotek.
   Wzorowane na filmach UGC (assets/motus-custom.js, sekcja 2).
   Film tła banera (.motus-sm__wideo-tlo, bez kontrolek, 27.09): ten sam start i pauza, bez przełącznika; plakat
   z data-motus-poster wpisywany dopiero, gdy film jest blisko ekranu, więc ukryty wariant (komputer / telefon,
   display: none) nie pobiera nawet plakatu. */
(() => {
  if (window.motusSmWideo) return;
  window.motusSmWideo = true;

  const SEL = '.motus-sm__wideo video, .motus-sm__wideo-tlo video';
  const reduce = window.matchMedia('(prefers-reduced-motion: reduce)');
  const saveData = Boolean(navigator.connection && navigator.connection.saveData);
  const blisko = new Set();
  const naszaPauza = new WeakSet();
  const pauzaKlienta = new WeakSet();
  const startKlienta = new WeakSet();
  const przyciski = new WeakMap();
  let io = null;

  const autostart = () => !reduce.matches && !saveData;
  const mozna = (video) => !pauzaKlienta.has(video) && (startKlienta.has(video) || autostart());

  /* co zrobi przełącznik: 'stop', gdy film gra albo ma grać przy ekranie; 'start', gdy ma stać
     albo stoi na ekranie mimo zgody (np. przeglądarka odrzuciła start, iOS w trybie oszczędzania energii) */
  const dzialanie = (video) => (mozna(video) && !(video.paused && blisko.has(video)) ? 'stop' : 'start');

  const odswiez = (video) => {
    const przycisk = przyciski.get(video);
    if (!przycisk) return;
    const d = dzialanie(video);
    if (przycisk.getAttribute('data-stan') === d) return;
    przycisk.setAttribute('data-stan', d);
    const napis = przycisk.querySelector('.motus-sm__wideo-napis');
    const tekst = przycisk.getAttribute(d === 'stop' ? 'data-napis-stop' : 'data-napis-start');
    if (napis && tekst) napis.textContent = tekst;
  };

  const graj = (video) => {
    video.muted = true;
    const obietnica = video.play();
    if (obietnica && typeof obietnica.catch === 'function') obietnica.catch(() => odswiez(video));
  };

  const zatrzymaj = (video) => {
    if (video.paused) return;
    naszaPauza.add(video);
    video.pause();
  };

  const przelacz = (video) => {
    if (dzialanie(video) === 'stop') {
      pauzaKlienta.add(video);
      startKlienta.delete(video);
      zatrzymaj(video);
    } else {
      pauzaKlienta.delete(video);
      startKlienta.add(video);
      graj(video);
    }
    odswiez(video);
  };

  const onIntersect = (wpisy) => {
    wpisy.forEach((wpis) => {
      const video = wpis.target;
      if (wpis.isIntersecting) {
        blisko.add(video);
        const plakat = video.getAttribute('data-motus-poster');
        if (plakat && !video.hasAttribute('poster')) video.setAttribute('poster', plakat);
        if (mozna(video)) graj(video);
      } else {
        blisko.delete(video);
        zatrzymaj(video);
      }
      odswiez(video);
    });
  };

  const init = () => {
    if (!('IntersectionObserver' in window)) return;
    if (!io) io = new IntersectionObserver(onIntersect, { rootMargin: '200px 0px' });
    blisko.forEach((video) => { if (!video.isConnected) blisko.delete(video); });
    document.querySelectorAll(SEL).forEach((video) => {
      if (video.hasAttribute('data-motus-sm-wideo')) return;
      video.setAttribute('data-motus-sm-wideo', '');
      video.muted = true;
      video.addEventListener('pause', () => {
        if (naszaPauza.has(video)) naszaPauza.delete(video);
        else if (video.controls && !document.hidden && blisko.has(video)) pauzaKlienta.add(video);
        odswiez(video);
      });
      video.addEventListener('play', () => {
        pauzaKlienta.delete(video);
        odswiez(video);
      });
      const ramka = video.closest('.motus-sm__wideo');
      const przycisk = ramka && ramka.querySelector('[data-motus-sm-pauza]');
      if (przycisk && !video.controls) {
        przyciski.set(video, przycisk);
        przycisk.addEventListener('click', () => przelacz(video));
        video.parentElement.addEventListener('click', () => przelacz(video));
        odswiez(video);
        przycisk.hidden = false;
      }
      io.observe(video);
    });
  };

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
  document.addEventListener('shopify:section:load', init);

  /* powrót do karty / aplikacji: film przy ekranie, zatrzymany przez przeglądarkę, rusza od razu (bez czekania na przewinięcie) */
  document.addEventListener('visibilitychange', () => {
    if (document.hidden) return;
    blisko.forEach((video) => { if (video.paused && mozna(video)) graj(video); });
  });

  const onReduce = () => {
    const filmy = document.querySelectorAll(SEL);
    if (reduce.matches) filmy.forEach((video) => { if (!startKlienta.has(video)) zatrzymaj(video); });
    else blisko.forEach((video) => { if (mozna(video)) graj(video); });
    filmy.forEach(odswiez);
  };
  if (typeof reduce.addEventListener === 'function') reduce.addEventListener('change', onReduce);
})();
